import api from '@/api/GeocodeApi'

export const state = {
  countries: []
}

export const getters = {
  countries(state) {
    return state.countries
  }
}

export const mutations = {
  SET_COUNTRIES(state, newValue) {
    state.countries = newValue
  }
}

export const actions = {
  afterSelectWorkspace({ commit, dispatch, rootState }) {
    dispatch('fetchCountries')
  },
  fetchCountries({ commit, state }, id) {
    return api.getCountries(id).then((response) => {
      const results = response.data.map(data => ({ code: data.gid_0, name: data.country }))
      commit('SET_COUNTRIES', results)
      return results
    })
  },
  fetchDetailCountry({ commit, state }, country) {
    return api.getDetailCountry(country.code).then((response) => {
      const results = response.data.data[0]
      return results
    })
  },
  fetchProvinces({ commit, state }, country) {
    return api.getStates(country.code).then((response) => {
      const results = response.data.map(data => ({
        code: data.gid_1,
        name: data.name_1
      }))
      return results
    })
  },
  fetchDistricts({ commit, state }, { country, province }) {
    return api.getDistricts(country.code, province.code).then((response) => {
      const results = response.data.map(data => ({
        code: data.gid_2,
        name: data.name_2
      }))
      return results
    })
  },
  fetchSubDistricts({ commit, state }, { country, province, district }) {
    return api.getSubDistricts(country.code, province.code, district.code).then((response) => {
      const results = response.data.map(data => ({
        code: data.gid_3,
        name: data.name_3
      }))
      return results
    })
  },
  getStateDetail({ commit, state }, province) {
    return api.getStateDetail(province.code).then((response) => {
      const results = response.data
      return results
    })
  },
  getDistrictDetail({ commit, state }, district) {
    return api.getDistrictDetail(district.code).then((response) => {
      const results = response.data
      return results
    })
  },
  getSubDistrictDetail({ commit, state }, subDistrict) {
    return api.getSubDistrictDetail(subDistrict.code).then((response) => {
      const results = response.data
      return results
    })
  },
  mergeDistricts({ commit, state }, districts) {
    return api.mergeDistricts(districts).then((response) => {
      const results = response.data
      return results
    })
  },
  mergeStates({ commit, state }, states) {
    return api.mergeStates(states).then((response) => {
      const results = response.data
      return results
    })
  },
  getStateDetails({ commit, state }, stateIds) {
    return api.getStateDetails(stateIds).then((response) => {
      const results = response.data
      return results
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/mapsearch.js